import { defineMessages } from 'react-intl';

export default defineMessages({

  tripCancellation: {
    id: 'fastCover.tripInterruptionStep.tripCancellation',
    defaultMessage: 'Are you claiming for Trip Cancellation?',
  },

  haveYouReceivedReimbursement: {
    id: 'fastCover.tripInterruptionStep.haveYouReceivedReimbursement',
    defaultMessage: 'Have you received reimbursement?',
  },

  travelInterruption: {
    id: 'fastCover.tripInterruptionStep.travelInterruption',
    defaultMessage: 'Are you claiming for Trip Interruption?',
  },

  travelDelay: {
    id: 'fastCover.tripInterruptionStep.travelDelay',
    defaultMessage: 'Are you claiming for Travel Delay?',
  },

  reasonsForTripInterruption: {
    id: 'fastCover.tripInterruptionStep.reasonsForTripInterruption',
    defaultMessage: 'Reasons for Trip Interruption',
  },

  reasons1: {
    id: 'fastCover.tripInterruptionStep.reasons1',
    defaultMessage: 'Death of an Immediate Family Member',
  },

  reasons2: {
    id: 'fastCover.tripInterruptionStep.reasons2',
    defaultMessage: 'Your Unforeseen Sickness or Injury or, the Sickness or Injury of a Traveling Companion or Immediate Family Member',
  },

  reasons3: {
    id: 'fastCover.tripInterruptionStep.reasons3',
    defaultMessage: 'Substantial destruction of your principal residence by fire or weather-related activity',
  },

  reasons4: {
    id: 'fastCover.tripInterruptionStep.reasons4',
    defaultMessage: 'A Medically Necessary covered Emergency Medical Evacuation to return to Your Home Country or to the area from which You were initially evacuated for continued treatment, recuperation, and recovery',
  },

  travelSupplier: {
    id: 'fastCover.tripInterruptionStep.travelSupplier',
    defaultMessage: 'Travel Supplier / Provider Information',
  },

  companyNameTravelInterruption: {
    id: 'fastCover.tripInterruptionStep.companyNameTravelInterruption',
    defaultMessage: 'Company Name',
  },

  addressTravelInterruption: {
    id: 'fastCover.tripInterruptionStep.addressTravelInterruption',
    defaultMessage: 'Address',
  },

  cityTravelInterruption: {
    id: 'fastCover.tripInterruptionStep.cityTravelInterruption',
    defaultMessage: 'City',
  },

  stateTravelInterruption: {
    id: 'fastCover.tripInterruptionStep.stateTravelInterruption',
    defaultMessage: 'State',
  },

  zipCodeTravelInterruption: {
    id: 'fastCover.tripInterruptionStep.zipCodeTravelInterruption',
    defaultMessage: 'Zip code',
  },

  contactTravelInterruption: {
    id: 'fastCover.tripInterruptionStep.contactTravelInterruption',
    defaultMessage: 'Contact',
  },

  phoneNumber: {
    id: 'fastCover.tripInterruptionStep.phoneNumber',
    defaultMessage: 'Phone Number',
  },

  includedInPackage: {
    id: 'fastCover.tripInterruptionStep.includedInPackage',
    defaultMessage: 'If not included in package, how was air travel arranged?',
  },

  lossInformation: {
    id: 'fastCover.tripInterruptionStep.lossInformation',
    defaultMessage: 'Loss Information',
  },

  addLossInformation: {
    id: 'fastCover.tripInterruptionStep.addLossInformation',
    defaultMessage: 'Add Loss Information',
  },

  dateTripInterrupted: {
    id: 'fastCover.tripInterruptionStep.dateTripInterrupted',
    defaultMessage: 'Date Trip was Interrupted',
  },

  lossInformationWithIdx: {
    id: 'fastCover.tripInterruptionStep.lossInformationWithIdx',
    defaultMessage: 'Loss information {idx}',
  },

  reasonForInterruption: {
    id: 'fastCover.tripInterruptionStep.reasonForInterruption',
    defaultMessage: 'Reason for interruption',
  },

  nameOfPersonHavingSickness: {
    id: 'fastCover.tripInterruptionStep.nameOfPersonHavingSickness',
    defaultMessage: 'Name of person having sickness of injury',
  },

  dateOfBirth: {
    id: 'fastCover.tripInterruptionStep.dateOfBirth',
    defaultMessage: 'His/Her date of birth',
  },

  relationshipToClaimant: {
    id: 'fastCover.tripInterruptionStep.relationshipToClaimant',
    defaultMessage: 'His/Her relationship to claimant',
  },

  dateSicknessOrInjuryBegan: {
    id: 'fastCover.tripInterruptionStep.dateSicknessOrInjuryBegan',
    defaultMessage: 'Date Sickness Or Injury began',
  },

  dateEnded: {
    id: 'fastCover.tripInterruptionStep.dateEnded',
    defaultMessage: 'Date ended',
  },

  natureOfSicknessOrInjury: {
    id: 'fastCover.tripInterruptionStep.natureOfSicknessOrInjury',
    defaultMessage: 'Nature of Sickness or Injury (If Injury, describe accident, including date and place):',
  },

  periodOfHospitalization: {
    id: 'fastCover.tripInterruptionStep.periodOfHospitalization',
    defaultMessage: 'Period of hospitalization (If applicable)',
  },

  companyNameLoss: {
    id: 'fastCover.tripInterruptionStep.companyNameLoss',
    defaultMessage: 'Company name (airline/hotel/cruise/travel agent/etc.)',
  },

  amountPaidLoss: {
    id: 'fastCover.tripInterruptionStep.amountPaidLoss',
    defaultMessage: 'Amount Paid (total for all insureds)',
  },

  amountOfLoss: {
    id: 'fastCover.tripInterruptionStep.amountOfLoss',
    defaultMessage: 'Amount of Loss (non-refundable amount)',
  },

  howMuchReceivedReimbursement: {
    id: 'fastCover.tripInterruptionStep.howMuchReceivedReimbursement',
    defaultMessage: 'How much?',
  },

  fromWhom: {
    id: 'fastCover.tripInterruptionStep.fromWhom',
    defaultMessage: 'If so, from whom?',
  },

  reasonsForDelay: {
    id: 'fastCover.tripInterruptionStep.reasonsForDelay',
    defaultMessage: 'Reasons for Delay',
  },

  reasons1ForTravelDelay: {
    id: 'fastCover.tripInterruptionStep.reasons1ForTravelDelay',
    defaultMessage: 'Delay of a Common Carrier (including Inclement Weather)',
  },

  reasons2ForTravelDelay: {
    id: 'fastCover.tripInterruptionStep.reasons2ForTravelDelay',
    defaultMessage: 'Delay by a traffic Accident enroute to a departure, in which You or Your Traveling Companion is not directly involved',
  },

  reasons3ForTravelDelay: {
    id: 'fastCover.tripInterruptionStep.reasons3ForTravelDelay',
    defaultMessage: 'Delay due to lost or stolen passport, travel documents or money, Quarantine, hijacking, unannounced Strike, Natural Disaster, civil commotion, or riot',
  },

  reasons4ForTravelDelay: {
    id: 'fastCover.tripInterruptionStep.reasons4ForTravelDelay',
    defaultMessage: 'A closed roadway causing cessation of travel to the destination of the Trip (substantiated by the department of transportation, state police, etc.)',
  },

  dateYouWereDueToDepart: {
    id: 'fastCover.tripInterruptionStep.dateYouWereDueToDepart',
    defaultMessage: 'Date you were due to depart',
  },

  timeYouWereDueToDepart: {
    id: 'fastCover.tripInterruptionStep.timeYouWereDueToDepart',
    defaultMessage: 'Time you were due to depart',
  },

  dateTripWasDelayed: {
    id: 'fastCover.tripInterruptionStep.dateTripWasDelayed',
    defaultMessage: 'Date trip was delayed with Travel Supplier',
  },

  dateYouActuallyDeparted: {
    id: 'fastCover.tripInterruptionStep.dateYouActuallyDeparted',
    defaultMessage: 'Date you actually departed',
  },

  timeYouActuallyDeparted: {
    id: 'fastCover.tripInterruptionStep.timeYouActuallyDeparted',
    defaultMessage: 'Time you actually departed',
  },

  delayInformation: {
    id: 'fastCover.tripInterruptionStep.delayInformation',
    defaultMessage: 'Delay Information',
  },

  addDelayInformation: {
    id: 'fastCover.tripInterruptionStep.addDelayInformation',
    defaultMessage: 'Add Delay Information',
  },

  delayInformationWithIdx: {
    id: 'fastCover.tripInterruptionStep.delayInformationWithIdx',
    defaultMessage: 'Delay information {idx}',
  },
  dateReimbursementReceived: {
    id: 'fastCover.tripInterruptionStep.dateReimbursementReceived',
    defaultMessage: 'Date Reimbursement Received',
  },

  yes: {
    id: 'fastCover.tripInterruptionStep.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'fastCover.tripInterruptionStep.no',
    defaultMessage: 'No',
  },
  fromDate: {
    id: 'fastCover.tripInterruptionStep.fromDate',
    defaultMessage: 'From Date',
  },
  toDate: {
    id: 'fastCover.tripInterruptionStep.toDate',
    defaultMessage: 'To Date',
  },

  //-----------------------------------------------------------------------------------------

  howItHappened: {
    id: 'fastCover.tripInterruptionStep.howItHappened',
    defaultMessage: '1. How it happened',
  },
  whereYouWereInRelationToTheItem: {
    id: 'fastCover.tripInterruptionStep.whereYouWereInRelationToTheItem',
    defaultMessage:
      'Provide details of where you were in relation to the item at the time of loss, theft or damage',
  },
  anyThingAdditionalToAdd: {
    id: 'fastCover.tripInterruptionStep.anyThingAdditionalToAdd',
    defaultMessage: 'Do you have any further details to add?',
  },
  areYouClaimingFor: {
    id: 'fastCover.tripInterruptionStep.areYouClaimingFor',
    defaultMessage: 'Are you claiming for',
  },
  loss: {
    id: 'fastCover.tripInterruptionStep.loss',
    defaultMessage: 'Loss',
  },
  theft: {
    id: 'fastCover.tripInterruptionStep.theft',
    defaultMessage: 'Theft',
  },
  damage: {
    id: 'fastCover.tripInterruptionStep.damage',
    defaultMessage: 'Damage',
  },
  delay: {
    id: 'fastCover.tripInterruptionStep.delay',
    defaultMessage: 'Delay',
  },
  whoDidYouReportThisTo: {
    id: 'fastCover.tripInterruptionStep.whoDidYouReportThisTo',
    defaultMessage: 'Who did you report this to?',
  },
  police: {
    id: 'fastCover.tripInterruptionStep.police',
    defaultMessage: 'Police',
  },
  hotelManagement: {
    id: 'fastCover.tripInterruptionStep.hotelManagement',
    defaultMessage: 'Hotel Management',
  },
  cruiseShip: {
    id: 'fastCover.tripInterruptionStep.cruiseShip',
    defaultMessage: 'Cruise Ship',
  },
  airline: {
    id: 'fastCover.tripInterruptionStep.airline',
    defaultMessage: 'Airline',
  },
  tourGuide: {
    id: 'fastCover.tripInterruptionStep.tourGuide',
    defaultMessage: 'Tour Guide',
  },
  other: {
    id: 'fastCover.tripInterruptionStep.other',
    defaultMessage: 'Other',
  },
  notReported: {
    id: 'fastCover.tripInterruptionStep.notReported',
    defaultMessage: 'Not Reported',
  },
  otherDescription: {
    id: 'fastCover.tripInterruptionStep.otherDescription',
    defaultMessage: 'If other, please describe',
  },
  reportReferenceNumber: {
    id: 'fastCover.tripInterruptionStep.reportReferenceNumber',
    defaultMessage: 'Report Reference Number',
  },
  descriptionOfItem: {
    id: 'fastCover.tripInterruptionStep.descriptionOfItem',
    defaultMessage: 'Description of item',
  },
  datePurchased: {
    id: 'fastCover.tripInterruptionStep.datePurchased',
    defaultMessage: 'Date purchased',
  },
  storeWhereItemWasPurchased: {
    id: 'fastCover.tripInterruptionStep.storeWhereItemWasPurchased',
    defaultMessage: 'Store where item was purchased',
  },
  purchasePrice: {
    id: 'fastCover.tripInterruptionStep.purchasePrice',
    defaultMessage: 'Purchase price',
  },
  currency: {
    id: 'fastCover.tripInterruptionStep.currency',
    defaultMessage: 'Currency',
  },
  amountClaimed: {
    id: 'fastCover.tripInterruptionStep.amountClaimed',
    defaultMessage: 'Amount claimed',
  },
  proofOfPurchaseAttached: {
    id: 'fastCover.tripInterruptionStep.proofOfPurchaseAttached',
    defaultMessage: 'Proof of purchase attached',
  },
  addAdditionalItem: {
    id: 'fastCover.tripInterruptionStep.addAdditionalItem',
    defaultMessage: 'Add Additional Item',
  },
  additionalItem: {
    id: 'fastCover.tripInterruptionStep.additionalItem',
    defaultMessage: 'Luggage and Personal Items',
  },
  item: {
    id: 'fastCover.tripInterruptionStep.item',
    defaultMessage: 'Item',
  },
  claimed: {
    id: 'fastCover.tripInterruptionStep.claimed',
    defaultMessage: 'Claimed',
  },
  nameOfTransportProvider: {
    id: 'fastCover.tripInterruptionStep.nameOfTransportProvider',
    defaultMessage:
      'Name of Transport Provider (airline, cruise liner, bus etc.)',
  },
  dateWhenYourLuggageWasDelayed: {
    id: 'fastCover.tripInterruptionStep.dateWhenYourLuggageWasDelayed',
    defaultMessage: 'Date when your luggage was delayed',
  },
  timeWhenYourLuggageWasDelayed: {
    id: 'fastCover.tripInterruptionStep.timeWhenYourLuggageWasDelayed',
    defaultMessage: 'Time when your luggage was delayed',
  },
  dateWhenYourLuggageWasReturned: {
    id: 'fastCover.tripInterruptionStep.dateWhenYourLuggageWasReturned',
    defaultMessage: 'Date when your luggage was returned',
  },
  timeWhenYourLuggageWasReturned: {
    id: 'fastCover.tripInterruptionStep.timeWhenYourLuggageWasReturned',
    defaultMessage: 'Time when your luggage was returned',
  },
  paidForDelay: {
    id: 'fastCover.tripInterruptionStep.paidForDelay',
    defaultMessage: 'Were you paid any compensation for this delay?',
  },
  madeClaimWithTravelProviderOrOther: {
    id: 'fastCover.tripInterruptionStep.madeClaimWithTravelProviderOrOther',
    defaultMessage:
      'Have you made a claim with your Travel Provider (Airline, hotel, cruise liner, tour company etc.) or any other company responsible for the loss, theft, damage or delay of your luggage?',
  },
  listedOnThePolicy: {
    id: 'fastCover.tripInterruptionStep.listedOnThePolicy',
    defaultMessage:
      'Are the luggage or personal item(s) lost, stolen, damaged or delayed owned by you or someone else listed on the policy?',
  },
  damagedLostOrStolenLuggageItems: {
    id: 'fastCover.tripInterruptionStep.damagedLostOrStolenLuggageItems',
    defaultMessage: 'Damaged, Lost or Stolen Luggage Items',
  },
  delayedLuggageExpenses: {
    id: 'fastCover.tripInterruptionStep.delayedLuggageExpenses',
    defaultMessage: 'Delayed Luggage Expenses',
  },
  delayedLuggageExpense: {
    id: 'fastCover.tripInterruptionStep.delayedLuggageExpense',
    defaultMessage: 'Delayed Luggage Expense',
  },
  isRequired: {
    id: 'fastCover.tripInterruptionStep.isRequired',
    defaultMessage: "'{defaultMessage}' is required",
  },
  expenseTableRequired: {
    id: 'fastCover.tripInterruptionStep.expenseTableRequired',
    defaultMessage: 'Expense table fields are mandatory fields.',
  },
  addDelayedLuggageExpense: {
    id: 'fastCover.tripInterruptionStep.addDelayedLuggageExpense',
    defaultMessage: 'Add Delayed Luggage Expense',
  },
  dateCompensationWasReceived: {
    id: 'fastCover.tripInterruptionStep.dateCompensationWasReceived',
    defaultMessage: 'Date compensation was received',
  },
  compensationDescription: {
    id: 'fastCover.tripInterruptionStep.compensationDescription',
    defaultMessage: 'Compensation description',
  },
  amountOfCompensation: {
    id: 'fastCover.tripInterruptionStep.delayedTravel.amountOfCompensation',
    defaultMessage: 'Compensation received',
  },
  amountOfCompensationCurrency: {
    id: 'fastCover.tripInterruptionStep.delayedTravel.amountOfCompensationCurrency',
    defaultMessage: 'Currency',
  },
  currencyEg: {
    id: 'fastCover.tripInterruptionStep.currencyEg',
    defaultMessage: 'E.g.Euro',
  },
  other1: {
    id: 'fastCover.tripInterruptionStep.other1',
    defaultMessage: 'Proof of loss (i.e. police report, report to hotel, airline, transport provider)',
  },
  other2: {
    id: 'fastCover.tripInterruptionStep.other2',
    defaultMessage: 'Proof of ownership/receipts/bank statements for each item',
  },
  other3: {
    id: 'fastCover.tripInterruptionStep.other3',
    defaultMessage: 'Written confirmation of an IMEI block from your network provider',
  },
  other4: {
    id: 'fastCover.tripInterruptionStep.other4',
    defaultMessage: 'A damage/repair report or quotation',
  },
  other5: {
    id: 'fastCover.tripInterruptionStep.other5',
    defaultMessage: 'Written confirmation of luggage delay',
  },
  other6: {
    id: 'fastCover.tripInterruptionStep.other6',
    defaultMessage: 'Receipts, bank statements and/or proof of payment for each expense being claimed',
  },
  itemWithIdx: {
    id: 'fastCover.tripInterruptionStep.itemWithIdx',
    defaultMessage: 'Item {idx}',
  },
  delayedLuggageExpenseWithIdx: {
    id: 'fastCover.tripInterruptionStep.delayedLuggageExpenseWithIdx',
    defaultMessage: 'Delayed Luggage Expense {idx}',
  },
  checkEventDate: {
    id: 'fastCover.tripInterruptionStep.checkEventDate',
    defaultMessage: "'{defaultMessage}' cannot be in the future.",
  },
  areYouCancellingTheTripDueToMedicalReasons: {
    id: 'fastCover.medicalExpenseStep.areYouCancellingTheTripDueToMedicalReasons',
    defaultMessage: 'Are you cancelling the trip due to medical reasons?',
  },
  dateTripWasCancelledWithTravelSupplier: {
    id: 'fastCover.tripInterruptionStep.dateTripWasCancelledWithTravelSupplier',
    defaultMessage: 'Date Trip was cancelled with Travel Supplier',
  },
  reasonForCancellation: {
    id: 'fastCover.tripInterruptionStep.reasonForCancellation',
    defaultMessage: 'Reason For Cancellation',
  },
  areYouInterruptingTheTripDueToMedicalReasons: {
    id: 'fastCover.tripInterruptionStep.areYouInterruptingTheTripDueToMedicalReasons',
    defaultMessage: 'Are you interrupting the trip due to medical reasons?',
  },
  schoolName: {
    id: 'fastCover.tripInterruptionStep.schoolName',
    defaultMessage: 'School Name',
  },
  dateTripWasDelayedWithTravelSupplier: {
    id: 'fastCover.tripInterruptionStep.dateTripWasDelayedWithTravelSupplier',
    defaultMessage: 'Date Trip was delayed with Travel Supplier',
  },
  detailsRegardingYourTripDelay: {
    id: 'fastCover.tripInterruptionStep.dateTripWasDelayedWithTravelSupplier',
    defaultMessage: 'Details regarding your Trip Delay',
  },
  dateDelayEnded: {
    id: 'fastCover.tripInterruptionStep.dateDelayEnded',
    defaultMessage: 'Date delay ended',
  },
  dateOfInitialPaymentDeposit: {
    id: 'fastCover.tripInterruptionStep.dateOfInitialPaymentDeposit',
    defaultMessage: 'Date of initial payment deposit',
  },
  insureds: {
    id: 'fastCover.tripInterruptionStep.addInsured',
    defaultMessage: 'Name(s) and birthdates of all claimants:',
  },
  birthDay: {
    id: 'fastCover.tripInterruptionStep.birthDay',
    defaultMessage: 'Birth Day',
  },
  fullName: {
    id: 'fastCover.tripInterruptionStep.fullName',
    defaultMessage: 'Full Name',
  },
  addInsured: {
    id: 'fastCover.tripInterruptionStep.addInsured',
    defaultMessage: 'Add Insured',
  },
  insuredInformationWithIdx: {
    id: 'fastCover.tripInterruptionStep.insuredInformationWithIdx',
    defaultMessage: 'Insured Information {idx}',
  },
  dateOfLoss: {
    id: 'fastCover.tripInterruptionStep.dateOfLoss',
    defaultMessage: 'Date Of Loss',
  },
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.NationWide.TripInterruptionStep/messages.js